<template>
    <div :class="['alert', `alert-${type}`, 'border-0', marginBottom, { 'alert-dismissible': dismissible }]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'AlertComponent',
    props: {
        type: {
            type: String,
            required: true
        },
        marginBottom: {
            type: String,
            default: 'mb-2'
        },
        dismissible: {
            type: Boolean,
            default: true
        }
    }
}
</script>